var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.49544 6.9987C7.99121 6.9987 9.20378 5.78614 9.20378 4.29036C9.20378 2.79459 7.99121 1.58203 6.49544 1.58203C4.99967 1.58203 3.78711 2.79459 3.78711 4.29036C3.78711 5.78614 4.99967 6.9987 6.49544 6.9987Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4008 9.02523L8.48325 10.9428C8.40742 11.0186 8.33701 11.1594 8.32076 11.2623L8.21784 11.9936C8.17992 12.259 8.36409 12.4431 8.62951 12.4052L9.36075 12.3023C9.46366 12.2861 9.60993 12.2157 9.68034 12.1398L11.5978 10.2223C11.9282 9.89191 12.0853 9.50731 11.5978 9.01981C11.1157 8.53773 10.7312 8.69482 10.4008 9.02523Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.125 9.30078C10.2875 9.88578 10.7425 10.3408 11.3275 10.5033",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.84375 12.4167C1.84375 10.3204 3.92918 8.625 6.49668 8.625C7.06001 8.625 7.60167 8.70625 8.10542 8.85791",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.5ac2e681d3c2a177c3dbc513ed3e25a0.svg";
export { ForwardRef as ReactComponent };